module.exports = __webpack_public_path__ + "img/style5.b958c127.png";